"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastTitle = exports.ToastFooter = exports.ToastBody = exports.Toast = exports.TOAST_SEMANTIC = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _Text = require("../Text");
var _typographyModule = _interopRequireDefault(require("../../styles/typography.module.css"));
var _ToastModule = _interopRequireDefault(require("./Toast.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TOAST_SEMANTIC = exports.TOAST_SEMANTIC = Object.freeze({
  success: 'success',
  information: 'information',
  warning: 'warning',
  danger: 'danger',
  primary: 'primary'
});
const ToastIcon = _ref => {
  let {
    semantic
  } = _ref;
  switch (semantic) {
    case 'success':
      return /*#__PURE__*/React.createElement(_Icon.Icon, {
        name: "circle-check",
        size: "medium",
        color: _Text.TEXT_COLORS.success,
        type: "solid"
      });
    case TOAST_SEMANTIC.information:
      return /*#__PURE__*/React.createElement(_Icon.Icon, {
        name: "circle-info",
        size: "medium",
        color: _Text.TEXT_COLORS.information,
        type: "solid"
      });
    case TOAST_SEMANTIC.warning:
      return /*#__PURE__*/React.createElement(_Icon.Icon, {
        name: "circle-exclamation",
        size: "medium",
        color: _Text.TEXT_COLORS.warning,
        type: "solid"
      });
    case TOAST_SEMANTIC.danger:
      return /*#__PURE__*/React.createElement(_Icon.Icon, {
        name: "shield-exclamation",
        size: "medium",
        color: _Text.TEXT_COLORS.danger,
        type: "solid"
      });
    default:
      return /*#__PURE__*/React.createElement(_Icon.Icon, {
        color: _Text.TEXT_COLORS.neutral,
        name: "face-smile",
        size: "medium",
        type: "solid"
      });
  }
};
const ToastTitle = exports.ToastTitle = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    // @ts-ignore
    semantic = '',
    className,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: (0, _classify.default)(_ToastModule.default.toastTitle, _typographyModule.default[semantic], className)
  }, props, {
    ref: ref
  }), children);
});
ToastTitle.displayName = 'ToastTitle';
const ToastBody = exports.ToastBody = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    children,
    className,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: (0, _classify.default)(_ToastModule.default.toastBody, className)
  }, props, {
    ref: ref
  }), children);
});
ToastBody.displayName = 'ToastBody';
const ToastFooter = _ref4 => {
  let {
    children,
    onClose
  } = _ref4;
  const arrayChildren = React.Children.toArray(children);
  const footerActions = React.Children.map(children, (child, index) => {
    const isLast = index === arrayChildren.length - 1;
    if (/*#__PURE__*/React.isValidElement(child)) {
      // @ts-ignore - TS2339 - Property 'onClick' does not exist on type 'unknown'.
      const {
        onClick
      } = child.props;
      const buttonClickHandler = e => {
        onClose && onClose();
        onClick && onClick(e);
      };

      // @ts-ignore - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
      if (child?.type?.displayName === 'Button' && isLast) {
        return /*#__PURE__*/React.cloneElement(child, {
          size: 'small',
          type: 'primary',
          // @ts-ignore - TS2698 - Spread types may only be created from object types.
          ...child.props,
          onClick: buttonClickHandler
        });
        // @ts-ignore - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
      } else if (child?.type?.displayName === 'Button') {
        return /*#__PURE__*/React.cloneElement(child, {
          size: 'small',
          type: 'tertiary',
          // @ts-ignore - TS2698 - Spread types may only be created from object types.
          ...child.props,
          onClick: buttonClickHandler
        });
      }
    }
    return child;
  });
  return React.Children.count(children) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: _ToastModule.default.toastFooterActions
  }, footerActions) : null;
};
exports.ToastFooter = ToastFooter;
ToastFooter.displayName = 'ToastFooter';
const Toast = _ref5 => {
  let {
    classNames,
    children,
    time,
    semantic = TOAST_SEMANTIC.success,
    onClose,
    initialFocus = -1,
    customIcon,
    hideCloseIcon
  } = _ref5;
  const {
    refs,
    context
  } = (0, _react2.useFloating)({
    open: true
  });
  const getComp = comp => {
    const childrenArray = React.Children.toArray(children);
    if (childrenArray.length) {
      const nodes = [];
      for (const child of childrenArray) {
        // @ts-ignore - TS2339 - Property 'type' does not exist on type 'string | number | bigint | ReactElement<unknown, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | Promise<...>'.
        if (child?.type?.displayName === comp) {
          // @ts-ignore - TS2769 - No overload matches this call.
          nodes.push(/*#__PURE__*/React.cloneElement(child, {
            semantic
          }));
        }
      }
      return nodes.length > 1 ? nodes : nodes[0];
    }
    return null;
  };
  const footer = getComp('ToastFooter');
  // @ts-ignore - TS2769 - No overload matches this call.
  const footerWithClose = footer ? /*#__PURE__*/React.cloneElement(footer, {
    onClose
  }) : null;
  return /*#__PURE__*/React.createElement(_react2.FloatingFocusManager, {
    context: context,
    initialFocus: initialFocus
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ToastModule.default.toastContainer, classNames?.wrapper),
    ref: refs.setFloating
  }, customIcon || /*#__PURE__*/React.createElement(ToastIcon, {
    semantic: semantic
  }), /*#__PURE__*/React.createElement("div", {
    className: _ToastModule.default.toastMidSection
  }, /*#__PURE__*/React.createElement("div", {
    className: _ToastModule.default.contentWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: _ToastModule.default.titleBodyWrap
  }, getComp('ToastTitle'), getComp('ToastBody')), time && /*#__PURE__*/React.createElement(_Text.SubTitleExtraSmall, {
    className: classNames?.time
  }, time)), footerWithClose), !hideCloseIcon && /*#__PURE__*/React.createElement(_Icon.CloseIcon, {
    classNames: {
      button: _ToastModule.default.closeIcon
    },
    onClick: onClose,
    ariaLabel: "Close Button"
  })));
};
exports.Toast = Toast;